import type { ReactNode } from "react";
import { Alert } from "@mantine/core";
import { useHostedSession } from "../hostedSession";
import { isManager } from "./types";
export function AccountsGate({ platform = false, children }: { platform?: boolean; children: ReactNode }) {
  const { session } = useHostedSession();
  const allowed = platform ? session?.user.is_platform_admin : isManager(session?.membership.role);
  return allowed ? <>{children}</> : <Alert color="yellow">Vous n’avez pas accès à la gestion de ces utilisateurs.</Alert>;
}
